import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import styles from 'features/auth/ui/Auth/Auth.module.scss';
import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import Box from 'shared/ui/Box/Box';
import LinkButton from 'shared/ui/Button/LinkButton/LinkButton';

import useAdditionalEmailConfirm from '../../model/useAdditionalEmailConfirm';

const AdditionalEmailConfirmScreen: React.FC = () => {
    const {message, status} = useAdditionalEmailConfirm();

    return (
        <BlankLayout>
            <div className={styles.wrapper}>
                <div className={styles.box_wrapper_confirm}>
                    <Box>
                        <div className="row text-center mb-3">
                            <div className="col-12">
                                <h2 className={styles.title}>
                                    {t`Подтверждение доп. E-mail`}
                                </h2>
                                {
                                    message && (
                                        <p className={cn('py-2 m-0', [status
                                            ? styles.confirm_email__msg
                                            : styles.confirm_email__msg_error])}
                                        >
                                            {message}
                                        </p>
                                    )
                                }
                            </div>
                        </div>

                        <LinkButton
                            href={AppUrls.SETTINGS}
                            primary
                            block
                        >
                            {t`Продолжить`}
                        </LinkButton>
                    </Box>
                </div>
            </div>
        </BlankLayout>
    );
};

export default AdditionalEmailConfirmScreen;
